<template>
    <div class="chargingTime">
      <title1
        type="1"
        title="光伏电站运维统计"
        subTitle="Electric Port Overview"
        :right="true"
      >
       <template v-slot:uuid>
       </template>
    </title1>
	<title1
	    type="2"
	    title="设备监控"
	    subTitle="Electric Port Overview"
	    :right="true"
	  >
	   <template v-slot:uuid>
	   </template>
	</title1>
      <div ref="pieone22" id="pieon22" class="pieon"></div>
    </div>
  </template>
   
  <script>
  import * as echarts from "echarts";
  import { onMounted, ref } from "vue";
  import title1 from "@/views/exposition/components/title3";
  import { dataInterface } from "@/api/dataInterfaceApi";
  export default {
    components: {
      title1,
    },
    data() {
      return {
        chart: null,
        target: [],
      };
    },
    mounted() {
      this.chargingTime();
    },
    methods: {
      // 创建图表
      createChartHandler() {
        this.chart = echarts.init(document.getElementById("pieon22"));
        this.chart.setOption(this.getChartOption(this.target));
        window.addEventListener("resize", () => {
          setTimeout(() => {
            this.chart.resize();
          });
        });
      },
      chargingTime() {
        let params = {
          "enCode": "zngf-dz-shebei-jiankong",// 接口code
              "@station_id": localStorage.getItem('guangfuStationId') ? localStorage.getItem('guangfuStationId') : "320500H001" // 接口传参
        };
        this.showcdata = false;
        dataInterface
          .dataFaceApi(params)
          .then((res) => {
            console.log(res, "设备监控");
            this.target.push(res[0].sbsl || 1);
            this.target.push(res[1].sbsl || 2);
            // this.target.push(data1.j_charge_duration || 3);
            // this.target.push(data1.p_charge_duration || 4);
            this.createChartHandler();
          })
          .catch((err) => {
            console.log(err);
          });
        return this.target;
      },
      getChartOption(data1) {
        // console.log(JSON.parse(JSON.stringify(data1)), "data1");
        const pieone22 = ref(null);
        const data = [
          { value: data1[0], name: "逆变器" },
          { value: data1[1], name: "汇流箱" },
          // { value: data1[2], name: "平" },
          // { value: data1[3], name: "谷" },
        ];
        // console.log('data:',data)
        this.chart.setOption({
          // 图例设置
          // legend: {
          //   orient: "vertical",
          //   top: "30%",
          //   right: "0%",
          //   itemWidth: 12,
          //   itemHeight: 8,
          //   // itemGap: 25,
          //   formatter: function (name) {
          //     //通过name获取到数组对象中的单个对象
          //     let singleData = data.filter(function (item) {
          //       return item.name == name;
          //     });
          //     let nameValue = singleData[0].value;
          //     return [`{num|${name}}` + `{name|${nameValue}}`];
          //   },
          //   textStyle: {
          //     color: ["#FFD15C", "#31C6C9", "#FFFFFF", "#20E6A4"],
          //     fontSize: 18,
          //     rich: {
          //       name: {
          //         fontSize: 18,
          //         fontFamily: "HT",
          //         // color: "#ffaa00",
          //         padding: [0, 0, 0,20], //上，右，下，左
          //       },
          //       num: {
          //         fontSize: 18,
          //         padding: [0, 0, 0, 0], //上，右，下，左
          //         // padding: [10, 10],
          //       },
          //     },
          //   },
          // },
          // 系列数据设置
          series: [
            {
              name: "Nightingale Chart", // 系列名称
              type: "pie", // 图表类型为饼图
              radius: [20, 150], // 饼图的内外半径
              center: ["50%", "50%"], // 饼图的中心位置
              roseType: "area", // 玫瑰图类型为区域玫瑰图
              itemStyle: {
                borderRadius: 4,
                // 数据项的样式设置
                normal: {
                  //取消指示提示文字
                  label: {
                  // formatter: "{b}: {}%",
                  formatter:function(data){
                    console.log(data,'sjisoissjisj')
	                  return `${data.name} ${data.value}`
	                },
                  show: true,
                  fontSize: 24,
                  fontFamily: "HT",
                },
                  // 取消指示提示线
                  labelLine: {
                    show: true,
                  },
                },
              },
              color: ["#FFD15C", "#31C6C9", "#FFFFFF", "#20E6A4"],
              // 数据
              data: data,
            },
          ],
        });
  
        return { pieone22 };
      },
    },
  };
  </script>
   
  <style scoped>
  @font-face {
    font-family: "HT";
    src: url("~@/assets/font/HT.ttf");
  }
  #pieon22 {
    width: 565 px;
    height: 400px;
    /* z-index: 10000; */
  }
  </style>